import axios from "axios";
const api = `https://${process.env.REACT_APP_IDENTITY_SERVER_APIID}.execute-api.eu-west-2.amazonaws.com/${process.env.REACT_APP_ASIMS_ENV}`;
const apiKey = process.env.REACT_APP_IDENTITY_SERVER_APIKEY;

export default axios.create({
    baseURL: api + "/",
    headers: {
        "Content-Type": "application/json",
        "x-api-key": apiKey ?? ""
    }
});
